export const animationDelay = 0.5;
export const headerHeight = 70;